import { VehicleStatusEnum } from '../../vehicles';

/**
 * Create vehicle availability tracking options DTO
 */
export class CreateVehicleAvailabilityTrackingOptionsDto {
	status!: VehicleStatusEnum;
	isAvailable!: boolean;
}
